<script>
export default {
  name: "IconInstagram"
};
</script>

<template>
  <svg width="21" height="21" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 0C16.3 0 21 4.7 21 10.5 21 16.299 16.299 21 10.5 21S0 16.299 0 10.5C0 4.7 4.701 0 10.5 0Zm2.458 4.33H8.042a3.702 3.702 0 0 0-3.697 3.697v4.916a3.702 3.702 0 0 0 3.697 3.698h4.916a3.703 3.703 0 0 0 3.698-3.698V8.027a3.703 3.703 0 0 0-3.698-3.697Zm0 1.158c1.4 0 2.54 1.139 2.54 2.54v4.915c0 1.4-1.14 2.54-2.54 2.54H8.042c-1.4 0-2.539-1.14-2.539-2.54V8.027c0-1.4 1.14-2.54 2.54-2.54ZM10.55 7.453a3.035 3.035 0 0 0-3.032 3.032 3.035 3.035 0 0 0 3.032 3.032 3.035 3.035 0 0 0 3.032-3.032 3.035 3.035 0 0 0-3.032-3.032Zm0 1.09c1.07 0 1.941.871 1.941 1.942 0 1.07-.87 1.942-1.941 1.942a1.944 1.944 0 0 1-1.943-1.942c0-1.07.872-1.942 1.943-1.942Zm3.209-2.015a.722.722 0 1 0 0 1.443.722.722 0 0 0 0-1.443Z"
      fill="#FFF"
      fill-rule="evenodd"
      opacity=".8"
    />
  </svg>
</template>
